// Gauge.js
import React from 'react';
import Highcharts from 'highcharts';
import highchartsMore from 'highcharts/highcharts-more';
import solidGauge from 'highcharts/modules/solid-gauge';
import HighchartsReact from 'highcharts-react-official';
import './Gauge.css';

// Initialize Highcharts modules safely
if (!Highcharts.seriesTypes || !Highcharts.seriesTypes.solidgauge) {
  highchartsMore(Highcharts);
  solidGauge(Highcharts);
}

const Gauge = ({ label, value, unit, target, color = '#3b82f6' }) => {
  const numericValue = parseFloat(value);
  const safeValue = isNaN(numericValue) ? 0 : Math.max(0, Math.min(100, numericValue));

  const options = {
    chart: {
      type: 'solidgauge',
      height: '100%',
      backgroundColor: 'transparent',
      spacing: [0, 0, 0, 0],
      style: { fontFamily: 'inherit' }
    },
    title: null,
    pane: {
      center: ['50%', '85%'],
      size: '100%',
      startAngle: -90,
      endAngle: 90,
      background: {
        backgroundColor: '#f8f9fa',
        innerRadius: '60%',
        outerRadius: '100%',
        shape: 'arc'
      }
    },
    tooltip: { enabled: false },
    yAxis: {
      min: 0,
      max: 100,
      lineWidth: 0,
      tickWidth: 0,
      minorTickInterval: null,
      tickAmount: 2,
      labels: {
        distance: 12,
        style: {
          fontSize: '10px',
          color: '#6b7280',
          fontWeight: '500'
        }
      }
    },
    plotOptions: {
      solidgauge: {
        dataLabels: { enabled: false },
        linecap: 'round',
        stickyTracking: false,
        rounded: true
      }
    },
    series: [{
      name: label,
      data: [{ // ✅ FIXED: Added "data:" property
        color: color,
        radius: '100%',
        innerRadius: '70%',
        y: safeValue
      }],
      animation: {
        duration: 800,
        easing: 'easeOutQuart'
      }
    }],
    credits: { enabled: false }
  };

  return (
    <div className="gauge-container">
      <div className="gauge-visual">
        <div className="highcharts-wrapper">
          <HighchartsReact
            highcharts={Highcharts}
            options={options}
            containerProps={{ style: { width: '100%', height: '100%' } }}
          />
        </div>
        <div className="gauge-value-text">
          {isNaN(numericValue) ? value : safeValue}
          {unit && <span className="gauge-unit-text">{unit}</span>}
        </div>
      </div>
      <div className="gauge-label">{label}</div>
      {target && <div className="gauge-target">{target}</div>}
    </div>
  );
};

export default Gauge;